<script>
    import { isDefined } from "../helper/utils";
    export default {
        name: "accordion-item-functional",

        render(createElement){

            const slotListElements = [];
            const slots = this.checkVisibleSlot();

            // return createElement(
            //     "div",
            //     [this.$slots.default]
            // )

            const iconsCollapse = [];
            if(this.showCollapseIcons && !this.isPreview){
                 const divIcon = createElement(
                    "div",
                    {
                        staticClass: "position-absolute d-flex",
                        class: this.alignmentIconClass,
                        style: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        }
                    },
                     [
                         createElement(
                             "i",
                             {
                                 staticClass: "fa m-3",
                                 class: [ (this.loopIndex === 0 && this.firstElementShown) ? this.iconActiveClass : this.iconClosedClass, this.customIconClass]
                             }
                         )
                     ]

                )

                iconsCollapse.push(divIcon)
            }

            const buttonAttrs = {};

            buttonAttrs["data-toggle"] = "collapse";
            buttonAttrs["data-target"] = `#content-${this.identifier}`;
            buttonAttrs["aria-expanded"] = [(this.loopIndex === 0 && this.firstElementShown)];
            buttonAttrs["aria-controls"] = `content-${this.identifier}`;

            const bodyAttrs = {
                id: `content-${this.identifier}`,
            };
            bodyAttrs["aria-labeledby"] = `heading-${this.identifier}`;
            bodyAttrs["data-parent"] = [(this.behavior === 'showOneCollapseRest') ? `#${this.accordionId}` : '']

            if(this.accordionVisible){

                const header = createElement(
                    "div",
                    {
                        class: this.headerClass,
                        attrs: {
                            id: `heading-${this.identifier}`
                        },
                    },
                    [
                        createElement(
                            "button",
                            {
                                staticClass: "btn btn-block btn-lg p-0 border-0",
                                class: [(this.loopIndex === 0 && this.firstElementShown) ? '' : 'collapsed' , (this.showCollapseIcons && !this.isPreview) ? 'position-relative' : ''],
                                attrs: buttonAttrs,
                            },
                            [
                                // createElement("h1", "HEADER SECTION"),
                                this.$slots.header,
                                iconsCollapse
                            ]
                        )
                    ]
                );

                const body = createElement(
                    "div",
                    {
                        staticClass: "collapse",
                        class: [(this.loopIndex === 0 && this.firstElementShown) ? 'show' : '' ,],
                        attrs: bodyAttrs,
                        ref: "myBody",
                    },
                    [this.$slots.default.filter(slot => !!slot.componentOptions)]
                );

                slotListElements.push(header);
                slotListElements.push(body);
            }

            return createElement(
                "div",
                {},
                slotListElements
            );

            // if(slots.length > 0){
            //     return createElement(
            //         "div",
            //         {},
            //         [
            //             createElement(
            //                 "div",
            //                 {
            //                     class: this.headerClass,
            //                     attrs: {
            //                         id: `heading-${this.identifier}`
            //                     },
            //                 },
            //                 [
            //                     createElement(
            //                         "button",
            //                         {
            //                             staticClass: "btn btn-block btn-lg p-0 border-0",
            //                             class: [(this.loopIndex === 0 && this.firstElementShown) ? '' : 'collapsed' , (this.showCollapseIcons && !this.isPreview) ? 'position-relative' : ''],
            //                             attrs: buttonAttrs,
            //                         },
            //                         [
            //                             // createElement("h1", "HEADER SECTION"),
            //                             this.$slots.header,
            //                             iconsCollapse
            //                         ]
            //                     )
            //                 ]
            //             ),
            //             createElement(
            //                 "div",
            //                 {
            //                     staticClass: "collapse",
            //                     class: [(this.loopIndex === 0 && this.firstElementShown) ? 'show' : '' ,],
            //                     attrs: bodyAttrs,
            //                     ref: "myBody",
            //                 },
            //                 [this.$slots.default.filter(slot => !!slot.componentOptions)]
            //             )
            //         ]
            //     )
            // }else{
            //     return createElement("div")
            //
            // }

        },
        props: {
            headerClass: String,
            identifier: String,
            showCollapseIcons: Boolean,
            isPreview: Boolean,
            alignmentIconClass: String,
            iconActiveClass: String,
            iconClosedClass: String,
            loopIndex: Number,
            firstElementShown: Boolean,
            customIconClass: String,
            behavior: String,
            accordionId: String
        },
        data () {
            return {
                accordionVisible: true,
                slotComponents: [],
                bodyHTML: null,
                slotHash: ""
            }
        },
        created() {
            this.$nextTick(() =>
            {
                // get all child tab components
                // console.log('Slots ', this.$slots);
                console.log('Slot body: ', this.$slots.default);
                this.slotComponents = (this.$slots.default || [])
                    .map((vnode) => vnode.componentInstance)
                    .filter((entry) => !!entry);
                // console.log('Slot Elements',this.slotComponents )
                //
                // const showItem = this.slotComponents.map( content => {
                //     console.log('TextContent, ', content.$el.textContent.trim().length > 0)
                //     console.log('Images, ', content.$el.querySelector("img, iframe"))
                //     return content.$el.textContent.trim().length > 0 || content.$el.querySelector("img, iframe")
                // });
                //
                // console.log('ShowItem:', showItem)
                // console.log('Show it ?:', showItem.includes(true))
                // this.accordionVisible =  showItem.includes(true)

            });
        },
        // mounted () {
        //     this.$nextTick(() => {
        //         if (this.showCollapseIcons && !this.isPreview) {
        //             // Se tienen que declarar antes las referencias de los props, para poder usarlos en Jquery
        //             const element = document.getElementById(`heading-${this.identifier}`)
        //             const iconClassHide = this.iconClosedClass
        //             const iconClassShow = this.iconActiveClass
        //             $(this.$refs.myBody).on('hide.bs.collapse', function () {
        //                 element.firstChild.lastChild.firstChild.classList.replace(iconClassShow, iconClassHide)
        //             })
        //             $(this.$refs.myBody).on('show.bs.collapse', function () {
        //                 element.firstChild.lastChild.firstChild.classList.replace(iconClassHide, iconClassShow)
        //             })
        //         }
        //     })
        // },
        updated()
        {
            const slots = this.checkVisibleSlot();
            console.log('Updated fired', slots);

            const showItem = slots.map( content => {
                console.log('------------------------')
                console.log('El', content.$el.textContent)
                console.log('TextContent, ', content.$el.textContent.trim().length > 0)
                console.log('Images, ', content.$el.querySelector("img, iframe"))
                return this.filterContent(content)
            });

            this.accordionVisible =  showItem.includes(true)




            const hash = slots.map((component) => component._uid).join("_");

            // need to check if visible tabs have been changed after rendering
            if (this.slotHash !== hash)
            {
                // visible tabs changed => need to re-render component
                this.slotHash = hash;
                this.$forceUpdate();
                console.log('Force Updated fired');

            }
        },
        methods:{
            checkVisibleSlot()
            {

                // filter visible tabs
                const slots = this.slotComponents.filter((slot) =>
                {
                    return isDefined(slot) &&
                        isDefined(slot.$slots.default) &&
                        this.filterContent(slot);
                    // console.log('Check Visible fired: ', this.slotComponents);
                    // return slot.$el.textContent.trim().length > 0 || slot.$el.querySelector("img, iframe")
                });

                return slots;
            },
            filterContent(slot)
            {
                return slot.$el.textContent.trim().length > 0 || slot.$el.querySelector("img, iframe");
            }
        }
    }
</script>
